import { Box, BoxProps, Text, TextProps } from '@jfs/ui-new'
import { getCarrencyFormat, getDecimalAsWhole } from '../../util/utill'

interface AmountTextProps {
  amount: string
}

export const AmountText = ({ amount }: AmountTextProps) => {
  const decimal = getDecimalAsWhole(+amount)
  return (
    <Box {...styles.container}>
      <Text {...styles.amountText}>{`₹ ${getCarrencyFormat(+amount | 0)}`}</Text>
      <Box justifyContent={'flex-end'} marginBottom={6}>
        <Text {...styles.amountPrefix}>{`.${decimal}`}</Text>
      </Box>
    </Box>
  )
}

const styles = {
  container: {
    flexDirection: 'row',
  } as BoxProps,
  amountText: {
    fontSize: 46,
    color: 'BLACK_21',
    fontFamily: 'jioType-light',
  } as TextProps,
  amountPrefix: {
    fontSize: 24,
    color: 'BLACK_21',
    fontFamily: 'jioType-light',
  } as TextProps,
}
